import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsEdit.vue?vue&type=template&id=19417459&scoped=true&"
import script from "./MonthAllowancesPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19417459",
  null
  
)

export default component.exports